import util from '@bmp-vue/core/api/util'

const controller = 'UserGroups'
export default Object.assign({}, util.GetCrud(controller, null), {
  SaveGroupsUser (dto) {
    return util.Axios.Post(`${controller}/SaveGroupsUser`, dto)
  },
  Save (dto) {
    return util.Axios.Post(`${controller}/Save`, dto)
  }
})
